import { Box, Button, InputBase, Modal, Paper } from "@mui/material";
import React, { useState } from "react";
import {
  APIUrlOne,
  APIUrlThree,
  APIUrlToken,
  GetOktaAuthData,
  logEvent,
} from "../../Utils/Utils";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import Loader from "../Loader/Loader";
const SalesForceMessageModal = ({
  open,
  setOpen,
  selectedOuterRows,
  setSelectedOuterRows,
  setIsSalesForceTrigger,
  decisionMakerData,
}) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "8px",
  };
  const userInfo = GetOktaAuthData();
  const [loading, setLoading] = useState();
  const loggedUser = userInfo?.user?.profile;
  const [ShowAutocompleteprimary, setShowAutocompleteprimary] = useState(false);
  const [ResponseDatanew, setResponseDatanew] = useState(null);
  const [primaryOrganization, setPrimaryOrganization] = useState("");
  const handlesearch = (e) => {
    setLoading(true);
    axios
      .get(
        `${APIUrlOne()}/v1/campaign_search?search=${primaryOrganization}&limit=50`,
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "X-API-Key": APIUrlToken(),
          },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          setShowAutocompleteprimary(true);
          setLoading(false);
          setResponseDatanew(response?.data?.campaigns);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  React.useEffect(() => {
    let timer;
    if (primaryOrganization?.length > 2) {
      timer = setTimeout(() => {
        handlesearch();
      }, 1000);
    }
    return () => clearTimeout(timer);
  }, [primaryOrganization]);
  const handelselectdata = (item) => {
    setShowAutocompleteprimary(true);
    setPrimaryOrganization(item);
    setShowAutocompleteprimary(false);
  };
  function normalizeEmails(emailString, primaryemail) {
    if (!emailString) return null; // Handle empty or null cases
    let data = emailString.replace(/^{|}$/g, "");
    let emails = data
      .split(",")
      .map((email) => email.trim())
      .filter((email) => email !== primaryemail);
    return emails.join(", ");
  }
  // const pushToSalesForce = () => {
  //     logEvent("push_to_salesforce", "JOI");
  //     setLoading(true);
  //     const ms = {
  //         updateData: {
  //             data: selectedOuterRows?.map((item) => ({
  //                 items: [item?.person_id, "Suspect"],
  //             })),
  //         },
  //     };
  //     const transformedData = selectedOuterRows
  //         ?.map((i) => {
  //             const organizationInfo =
  //                 decisionMakerData.find((org) => org?.org_id === i?.org_id) || {};
  //             return { ...i, organizationInfo };
  //         })
  //         ?.map((item) => ({
  //             attributes: {
  //                 type: "Lead",
  //                 referenceId: "rec" + item?.person_id,
  //             },
  //             LastName: (item?.last_name),
  //             FirstName: (item?.first_name),
  //             Salutation: null,
  //             Email: item?.email,
  //             ...(item?.emails ? { Alternate_Emails__c: normalizeEmails(item?.emails, item?.email) } : {}),
  //             Phone: item?.phone_no,
  //             Title: item?.raw_job_title?.toLowerCase()?.replace(/\b\w/g, (char) => char?.toUpperCase()),
  //             Company: item?.primary_organization,
  //             City: item?.organizationInfo?.location_identifiers?.split(",")[0],
  //             State: item?.organizationInfo?.location_identifiers?.split(",")[1],
  //             Country: item?.organizationInfo?.country,
  //             LeadSource: "JOI",
  //             Status: "Suspect",
  //             LinkedIn_Profile__c: item?.linkedin,
  //             Suspect_Source_Detail__c: `${loggedUser?.firstName} ${loggedUser?.lastName}`,
  //         }));
  //     const finalJson = { records: transformedData, ...ms };
  //     const option = {
  //         method: "POST",
  //         headers: {
  //             "access-control-allow-origin": "*",
  //             "content-type": "application/json",
  //             "X-API-Key": APIUrlToken()
  //         },
  //         data: finalJson,
  //         url: `${APIUrlOne()}/v1/add_suspects`,
  //     };
  //     axios(option)
  // .then(async (response) => {
  //     setLoading(false);
  //     if (response?.status === 200) {
  //         if (primaryOrganization) {
  //             // === NEW CODE STARTS HERE ===
  //             const sfResponse = response.data?.salesforce_response || [];
  //             const allResults = sfResponse
  //                 .filter(item => item?.data?.results?.length)
  //                 .flatMap(item => item.data.results);
  //             addToCampaign(allResults, ms);
  //             // === NEW CODE ENDS HERE ===
  //         } else {
  //             setOpen(false);
  //             setSelectedOuterRows([]);
  //             setIsSalesForceTrigger(false);
  //             toast.success("Records pushed to salesforce.");
  //         }
  //     }
  // })
  // .catch((err) => {
  //     setLoading(false);
  //     toast.error(err?.response?.data?.message);
  // });
  // };
  // const addToCampaign = (results, ms) => {
  //     setLoading(true);
  //     const transformedData = results
  //         ?.map((item) => ({
  //             attributes: {
  //                 type: "CampaignMember",
  //                 referenceId: item?.referenceId,
  //             },
  //             CampaignId: primaryOrganization.campaign_id,
  //             LeadId: item?.id
  //         }));
  //     const finalJson = { records: transformedData, ...ms };
  //     const option = {
  //         method: "POST",
  //         headers: {
  //             "access-control-allow-origin": "*",
  //             "content-type": "application/json",
  //             "X-API-Key": APIUrlToken()
  //         },
  //         data: finalJson,
  //         url: `${APIUrlOne()}/v1/add_to_campaign`,
  //     };
  //     axios(option)
  //         .then(async (response) => {
  //             setLoading(false);
  //             if (response?.status === 200) {
  //                 setSelectedOuterRows([]);
  //                 setOpen(false)
  //                 setIsSalesForceTrigger(false)
  //                 toast.success("Records pushed to salesforce.")
  //             }
  //         })
  //         .catch((err) => {
  //             setLoading(false);
  //             setSelectedOuterRows([]);
  //             setOpen(false)
  //             setIsSalesForceTrigger(false)
  //             toast.error(err?.response?.data?.message);
  //         });
  // }

  const pushToSalesForce = () => {
    logEvent("push_to_salesforce", "JOI");
    setLoading(true);

    // Prepare updateData from selected rows
    const updateData = {
      data: selectedOuterRows?.map((item) => ({
        items: [item?.person_id, "Suspect"],
      })),
    };

    // Prepare records array
    const transformedData = selectedOuterRows
      ?.map((i) => {
        const organizationInfo =
          decisionMakerData.find((org) => org?.org_id === i?.org_id) || {};
        return { ...i, organizationInfo };
      })
      ?.map((item) => ({
        attributes: {
          type: "Lead",
          referenceId: "rec" + item?.person_id,
        },
        LastName: item?.last_name,
        FirstName: item?.first_name,
        Salutation: null,
        Email: item?.email,
        ...(item?.emails
          ? { Alternate_Emails__c: normalizeEmails(item?.emails, item?.email) }
          : {}),
        Phone: item?.phone_no,
        Title: item?.raw_job_title
          ?.toLowerCase()
          ?.replace(/\b\w/g, (char) => char?.toUpperCase()),
        Company: item?.primary_organization,
        City: item?.organizationInfo?.location_identifiers?.split(",")[0],
        State: item?.organizationInfo?.location_identifiers?.split(",")[1],
        Country: item?.organizationInfo?.country,
        LeadSource: "JOI",
        Status: "Suspect",
        LinkedIn_Profile__c: item?.linkedin,
        Suspect_Source_Detail__c: `${loggedUser?.firstName} ${loggedUser?.lastName}`,
        // Optional fields from new API (you can map if data exists)
        Street: item?.organizationInfo?.street || "",
        PostalCode: item?.organizationInfo?.postal_code || "",
        MobilePhone: item?.mobile_phone || "",
        Fax: item?.fax || "",
        Website: item?.website || "",
        Description: item?.description || "",
        Industry: item?.categories || "",
        Suspect_Cluster__c: item?.categories || "",
      }));

    // Final JSON for new API
    const finalJson = {
      campaignId: primaryOrganization?.campaign_id || "",
      updateData: updateData,
      records: transformedData,
    };

    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      data: finalJson,
      url: `${APIUrlOne()}/v1/add_suspects_and_campaigns`,
    };

    axios(option)
      .then((response) => {
        setLoading(false);
        if (response?.status === 202) {
          setSelectedOuterRows([]);
          setOpen(false);
          setIsSalesForceTrigger(false);
          toast.success("Records pushed to salesforce.");
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="vrufyerv">
          <Box sx={style} style={{ overflowY: "auto" }}>
            <div className="de_pad">
              <h3>{`Are you sure that you want to push ${
                selectedOuterRows?.length > 1 ? "these records" : "this record"
              } to Salesforce?`}</h3>
              {selectedOuterRows?.length ? (
                <p>{selectedOuterRows?.length} record selected</p>
              ) : null}
              <div className="label-form-prospect-salesforce">
                <label htmlFor="" className="label-floating-salesforce">
                  JOSF Campaign Name (Optional)
                </label>
                <Paper
                  className="full-searchbar-ai-profile"
                  component="form"
                  sx={{
                    p: "2px 4px",
                    display: "flex",
                    alignItems: "center",
                    width: 400,
                  }}
                >
                  <InputBase
                    value={primaryOrganization?.campaign_name}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      setPrimaryOrganization(inputValue);
                    }}
                    className="search-inner-textai-profile"
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Search"
                    inputProps={{ "aria-label": "Search google maps" }}
                    autoComplete="off"
                  />
                  <div
                    onClick={() => {
                      setPrimaryOrganization("");
                      setShowAutocompleteprimary(false);
                    }}
                    className="cross-icon-prospect"
                  >
                    {primaryOrganization?.length ? (
                      <CloseIcon className="showicons" />
                    ) : null}
                  </div>
                  <div className="PrimaryOrganizationoutter">
                    {ShowAutocompleteprimary ? (
                      <div className="PrimaryOrganization-data-salesforce">
                        <div
                          className={
                            ResponseDatanew === "" ||
                            ResponseDatanew?.length > 0
                              ? "-aiprofile "
                              : "sethjgcghjiohgh"
                          }
                        >
                          {ResponseDatanew && ResponseDatanew.length > 0 ? (
                            ResponseDatanew?.map((item) => {
                              return (
                                <>
                                  <div
                                    className="innerAutocomplete"
                                    onClick={() => handelselectdata(item)}
                                  >
                                    {item?.campaign_name}
                                  </div>
                                  <div className="separatorline"></div>
                                </>
                              );
                            })
                          ) : (
                            <div
                              className={
                                ResponseDatanew?.length === 0
                                  ? "nodatafound"
                                  : "degtyrrf"
                              }
                            >
                              {primaryOrganization?.length ||
                              ResponseDatanew?.length === 0
                                ? "Not available"
                                : ""}
                            </div>
                          )}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </Paper>
              </div>
              <div className="de_hr">
                <div className="de_btn_cont">
                  <Button
                    className="de_cancel"
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button className="de_next" onClick={pushToSalesForce}>
                    Push
                  </Button>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </Modal>
    </>
  );
};
export default SalesForceMessageModal;
